module.exports = __webpack_public_path__ + "img/PARTLY_CLOUDY_DAY_bg.fd6e1f0f.png";